import { Component } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class ApartmentsLocationsHeadingBlock extends BaseBlock {
}

export default ApartmentsLocationsHeadingBlock;
